// AD-7 r5 · Linkage Amendment (Feb 20, 2026) — operator-locked copy.
// Three verbatim strings that appear on the authenticated AD-7
// private Professional Passport view only. Never on the AD-8
// public page.
//
// Doctrine constraints:
// - No word implying the public passport is enabled, live, visible,
//   seen, active, or shared.
// - No marketing tokens (promote, showcase, boost, attract, ...).
// - No metric tokens (views, visitors, impressions, clicks, reach).
// - Neutral secondary-action wording only.
//
// Any edit here requires a paired doctrine amendment.

export const AD7_ACTIONS_SECTION_HEADING = "Public passport settings";

export const AD7_ACTIONS_SUPPORTING_LINE =
  "Choose whether to share a public view of your current professional practice.";

export const AD7_ACTIONS_BUTTON_LABEL = "Manage public passport";

// Target route — the already-registered authenticated AD-8 settings surface.
export const AD7_ACTIONS_NAVIGATION_TARGET = "/passport/professional/public/settings";
